import styled from 'styled-components';

export const ContainerConfirmPassword = styled.div`
  h4 {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.63;
    letter-spacing: 0.01px;
    text-align: center;
    color: #292929;
  }
  div.confirmSenha {
    width: 78%;
    margin: 20px auto 0 auto;
    padding-top: 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.16);

    span {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      text-align: center;
      color: #cc0000;
    }
  }

  div.confirmInputSenha {
    margin: 10px auto 30px auto;
  }
`;
